import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, ObservableInput, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FlashMessageErrorHandlerService } from '../flash-message-error-handler/flash-message-error-handler.service';
import { ExceptionStackError } from '../../errors/ExceptionStackError';

@Injectable({
    providedIn: 'root',
})
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private flashMessageErrorHandlerService: FlashMessageErrorHandlerService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: any): ObservableInput<any> => {
                if (error instanceof HttpErrorResponse) {
                    const errorSkippable =
                        error.url?.includes('i18nTranslation') || error.url?.includes('/confirmation');

                    if (!errorSkippable) {
                        this.flashMessageErrorHandlerService.errorSubject.next(error);
                        this.flashMessageErrorHandlerService.errorStack.push(error);

                        // a 400 is a handled client error (e.g. slot already booked) and the booking
                        // flow continues on the page — wiping the session would break its recovery
                        if (error.status !== 400) {
                            sessionStorage.clear();
                        }
                    }
                }
                return throwError(() => new ExceptionStackError(error?.message, error?.error));
            }),
        );
    }
}
